import WebView from "./StickyBarWeb";
import { useMediaQuery } from "@mui/material";
import MobileView from "./StickyMobile";
export default function Sticky() {
    const isSmallScreen = useMediaQuery("(max-width:960px)");
    return <>{isSmallScreen ? <MobileView /> : <WebView />}</>;
}
